module.exports = __webpack_public_path__ + "static/media/down-arrow.bb010aea.svg";